import { createStore } from 'vuex'

function getDefaultLanguage() {
  // 直接取字符串再转数字
  const saved = localStorage.getItem('language');
  return saved !== null ? Number(saved) : 1;
}

function getDefaultLanguageLabel() {
  const saved = localStorage.getItem('languageLabel');
  return saved !== null ? saved : "Chinese (Traditional)";
}

export default createStore({
  state: {
    language: getDefaultLanguage(),
    languageLabel: getDefaultLanguageLabel()
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
      // 本地存储字符串
      localStorage.setItem('language', String(language));
    },
    setLanguageLabel(state, languageLabel) {
      state.languageLabel = languageLabel;
      localStorage.setItem('languageLabel', languageLabel);
    }
  },
  actions: {
    updateLanguage({ commit }, language) {
      commit('setLanguage', language);
    },
    updateLanguageLabel({ commit }, languageLabel) {
      commit('setLanguageLabel', languageLabel);
    }
  },
  getters: {
    getLanguage: state => state.language,
    getLanguageLabel: state => state.languageLabel,
  }
});